export interface HealthHistorydiseaseTypes {
  alert?: boolean,
  aproach?: string,
  cid?: string,
  denies?: boolean,
  diseasefree?: string,
  insertDiagnosis?:boolean,
  insertProblems?: boolean,
  level?: string,
  notes?: string,
  pathologic?: string,
  recordDate?: string,
  sae?: string,
  situation?: string

}

export enum HealthHistoryType {
  ALLERGIES      = '12',
  DISEASES       = '24',
  MEDICINES      = '30',
  SOCIAL_HISTORY = '48'
}

export interface DomainType {
  description: string;
  valueDomain: string;
}

export interface SearchType {
  activeIngredientRequired: string;
  dcbRequired: string;
  description: string;
  id: number;
  medicine: string;
  unregistered: string;
}

export interface SaeSearch {
  description: string;
  id: number;
}

export interface RadioType {
  key: string;
  label: string;
  value: string;
}

export interface SearchStringType {
  description: string;
  id: string;
}

export interface DiseasesType {
  diagnosisDescription: string ;
  diseaseCode: string ;
}

export interface PersonType {
  professionalCode: string;
  professionalName: string;
}

export enum DateTypeId {
  DAY_MONTH_YEAR = '1',
  MONTH_YEAR     = '2',
  YEAR           = '3'
}

export enum DateTypeEntry {
  DAY_MONTH_YEAR = 'startDate',
  MONTH_YEAR     = 'startMonth',
  YEAR           = 'startYear'
}

export enum DateHandleStartOf {
  START_YEAR  = 'year',
  START_MONTH = 'month'
}

export interface HealthHistoryAllergiesResponse {
  activeIngredient?: SearchType;
  approach?: DomainType;
  causativeAgent?: SearchType;
  classification?: string;
  condition?: string;
  dateType?: DomainType;
  dcb?: SearchType;
  deniesAllergies?: string;
  endDate?: string;
  family?: SearchType;
  highlightIntensitySeverity?: string;
  idHealthHistory?: number;
  lastDate?: string;
  material?: SearchType;
  materialClass?: SearchType;
  notes?: string;
  origin?: DomainType;
  patientAlerts?: string;
  problemsList?: string;
  professional?: SearchStringType;
  reactionType?: SearchType;
  recordDate?: string;
  reviewDate?: string;
  reviewUsername?: string;
  securityLevel?: SearchType;
  showInactivate?: boolean;
  startDate?: string;
  startMonth?: string;
  startYear?: number;
  unregisteredCausativeAgent?: string;
}

export interface HealthHistoryAllergiesRequest {
  activeIngredientDescription: string;
  approachDescription: string;
  causativeAgentDescription: string;
  classification: string;
  condition: string;
  dateTypeDescription: string;
  dcbDescription: string;
  deniesAllergies: boolean;
  endDate: string;
  familyDescription: string;
  highlightIntensitySeverity: string;
  idHealthHistory?: number;
  lastDate: string;
  materialClassDescription: string;
  materialDescription: string;
  notes: string;
  originDescription: string;
  patientAlerts: boolean;
  problemsList: boolean;
  professionalName: string;
  reactionTypeDescription: string;
  recordDate: string;
  securityLevelDescription: string;
  startDate: string;
  startMonth: string;
  startYear: number;
}

export interface HealthHistoryDiseasesResponse {
  approachDescription?: string;
  attendance: string;
  classification?: string;
  condition?: string;
  deniesDiseases?: string;
  disease?: DiseasesType;
  diseaseAvailableDescription?: string;
  displayPatientAlerts?: string ;
  endDate?: string;
  highlightIntensitySeverity: string;
  hour?: DomainType;
  idHealthHistory: number ;
  insertDiagnosis?: string;
  insertProblemsList?: string;
  notes: string;
  origin?: DomainType;
  pathology?:DomainType;
  professional?: SearchStringType;
  recordDate?: string;
  reviewDate?: string;
  reviewUsername?: string;
  sae?: SearchType;
  securityLevel?: SearchType;
  securityLevelCode?: SearchType;
  showInactivate?: boolean;
  startDate?: string;
  status?: DomainType;
  time?: number;
}

export interface HealthHistoryDiseasesRequest {
  approachDescription?: string;
  attendance?: number;
  classification?: string;
  condition?: string;
  dateType?: DomainType;
  deniesDiseases?: boolean;
  disease:string;
  diseaseAvailableDescription?: string;
  displayPatientAlerts: boolean;
  endDate?: string;
  highlightIntensitySeverity: string;
  idHealthHistory: number;
  insertDiagnosis?: boolean;
  insertProblemsList?: boolean;
  notes: string;
  pathology:string;
  professional?: PersonType;
  recordDate?: string;
  reviewDate?: string;
  reviewUsername?: string;
  sae?:string;
  securityLevel?:string,
  securityLevelDescription: string;
  startDate?: string;
  status?:string;
  time?: number;
}

export interface HealthHistorySocialHistoryResponse {
  ageExperience?: string;
  ageRegularUse?: string;
  alert?: string;
  amount?: string;
  antecedents?: string;
  brand?: SearchType;
  classification?: DomainType;
  condition?: string;
  consequences?: string;
  deniesHabits?: string;
  descriptiveQuantity?: string;
  duration?: string;
  endDate?: string;
  frequency?: DomainType;
  idHealthHistory: number;
  notes?: string;
  physicalPerson?: string;
  problemList?: string;
  professional: SearchStringType;
  recordDate: string;
  reviewDate?: string;
  reviewUsername?: string;
  securityLevel?: SearchType;
  showInactivate?: boolean;
  startDate?: string;
  totalPacks?: string;
  type?: SearchType;
  unitMeasure?: SearchType;
}

export interface HealthHistorySocialHistoryRequest {
  ageExperience?: string;
  ageRegularUse?: string;
  alert?: boolean;
  amount?: string;
  antecedents?: string;
  brandDescription?: string;
  classificationDescription?: string;
  condition?: string;
  consequences?: string;
  deniesHabits?: boolean;
  descriptiveQuantity?: string;
  duration?: string;
  endDate?: string;
  frequencyDescription?: string;
  idHealthHistorySocialHistory?: number;
  notes?: string;
  physicalPerson?: string;
  problemList?: boolean;
  professionalName: string;
  recordDate: string;
  reviewDate?: string;
  reviewUsername?: string;
  securityLevelDescription?: string;
  startDate?: string;
  totalPacks?: string;
  typeDescription?: string;
  unitMeasureDescription?: string;
}

export interface HealthHistoryMedicineResponse {
  administrationChannel?: DomainType;
  alertDescription: string;
  beginningDate?: DomainType;
  continuousMedication: SearchStringType;
  dateLastDose?: string;
  endDate?: string;
  firstTrimester: string;
  idHealthHistory: number;
  interruptReason?: DomainType;
  interval?: DomainType;
  justificationForEnd?: DomainType;
  medicationDescription?: SearchType;
  observation?: string;
  professional: SearchStringType;
  provenance?: DomainType;
  qtDose?: number;
  reaction?: string;
  recordDate: string;
  reviewDate?: string;
  reviewUsername?: string;
  schedules?: string;
  secondTrimester: string;
  securityLevel?: SearchType;
  selfMedication: string;
  showInactivate?: boolean;
  startDate?: string;
  startMonth?: string;
  startYear?: number;
  thirdTrimester: string;
  unityMeasurement?: DomainType;
  unknownEnd: string;
  unknownInfoMedication: string;
  unknownLastDose: string;
  unknownStart: string;
  unregisteredMedication?: string;
}

export interface HealthHistoryMedicineRequest {
  administrationChannel?: string;
  alertDescription: boolean;
  beginningDate?: string;
  continuousMedication: string;
  dateLastDose?: string;
  endDate?: string;
  firstTrimester: boolean;
  idHealthHistory: number;
  interruptReason?: string;
  interval?: string;
  medicationDescription?: string;
  observation?: string;
  professionalName: string;
  provenance?: string;
  qtDose?: number;
  reaction?: string;
  recordDate: string;
  reviewDate?: string;
  reviewUsername?: string;
  schedules?: string;
  secondTrimester: boolean;
  securityLevel?: string;
  selfMedication: boolean;
  startDate?: string;
  thirdTrimester: boolean;
  unityMeasurement?: string;
  unknownEnd: boolean;
  unknownInfoMedication: boolean;
  unknownLastDose: boolean;
  unknownStart: boolean;
  unregisteredMedication?: string;
}
